module.exports = __webpack_public_path__ + "static/img/user.bd93c3fa.png";